export function getCurrentLanguage() {
	return getLanguagePart(document.documentElement.lang || "en");
}
export function pageSatisfiesLanguageRequirement(): boolean {
	const currentLocale = document.documentElement.lang || "en";
	const chosenLocale = getChosenLocale();
	if (chosenLocale !== null) {
		return currentLocale === chosenLocale || getLanguagePart(chosenLocale) === getLanguagePart(currentLocale);
	}
	return navigator.languages.includes(currentLocale) || navigator.languages.map(getLanguagePart).includes(getLanguagePart(currentLocale));
}

export function getLanguagePart(locale: string) {
	return locale.split(/[_-]/g)[0];
}

export function getChosenLocale() {
	return localStorage.getItem("magnattack/chosen-locale");
}
export function setChosenLocale(chosenLocale: string) {
	localStorage.setItem("magnattack/chosen-locale", chosenLocale);
}

export function addChosenLocaleUpdater(clickable: Element) {
	clickable.addEventListener('click', () => {
		setChosenLocale(clickable.querySelector<HTMLElement>(".wpml-ls-native[lang]")?.lang || getCurrentLanguage());
	});
}

export function getAvailableLocales() {
	const availableLocales: Record<string, string> = {};
	for (const alternate of document.head.querySelectorAll<HTMLLinkElement>("link[rel='alternate'][hreflang]")) {
		if (!alternate.hreflang || !alternate.href || alternate.hreflang === "x-default") {
			continue;
		}
		availableLocales[alternate.hreflang] = alternate.href;
		const language = getLanguagePart(alternate.hreflang);
		if (!availableLocales[language]) {
			availableLocales[language] = alternate.href;
		}
	}
	return availableLocales;
}
